import type ICard from '../../../models/tap-and-go/card.model';

export default class CardApiModel {
  public static mapToBusinessModel(apiModel: CardApiModel): ICard {
    return {
      id: apiModel.id,
      cardNumber: apiModel.cardNumber,
      type: apiModel.type,
    };
  }

  public id!: string;
  public cardNumber!: string;
  public type!: string;
}
